/**
 * Normalization between Connection API billing periods and Club Settings / Finance UI.
 */

export { PERIOD_LABEL_NOT_USED } from "./billingPeriodConstants";

/**
 * @param {unknown} p
 * @returns {ReturnType<typeof normalizeBillingPeriodFromApi>}
 */
export function normalizeBillingPeriodFromApi(p) {
  if (!p || typeof p !== "object") return null;
  const licenseRaw = p.licenseYearLabel ?? p.license_year_label;
  const parentRaw = p.parentPeriodId ?? p.parent_period_id;
  return {
    id: String(p.id),
    name: typeof p.name === "string" ? p.name : "",
    sport: typeof p.sport === "string" ? p.sport : "",
    calendarYear:
      typeof p.calendarYear === "number"
        ? p.calendarYear
        : typeof p.calendar_year === "number"
          ? p.calendar_year
          : new Date().getFullYear(),
    startDate: String(p.startDate ?? p.start_date ?? "").slice(0, 10),
    endDate: String(p.endDate ?? p.end_date ?? "").slice(0, 10),
    membershipYearLabel: String(p.membershipYearLabel ?? p.membership_year_label ?? ""),
    licenseYearLabel:
      licenseRaw == null || licenseRaw === ""
        ? "__NOT_USED__"
        : String(licenseRaw),
    familyMembershipMode:
      (p.familyMembershipMode ?? p.family_membership_mode) === "on" ? "on" : "off",
    isActive: Boolean(p.isActive ?? p.is_active),
    isHidden: Boolean(p.isHidden ?? p.is_hidden),
    parentPeriodId:
      parentRaw == null || parentRaw === "" ? null : String(parentRaw),
    invoiceCount: Number(p.invoiceCount ?? p.invoice_count ?? 0) || 0,
    groupCount: Number(p.groupCount ?? p.group_count ?? 0) || 0,
    memberCount: Number(p.memberCount ?? p.member_count ?? 0) || 0,
    hasInvoices: Boolean(p.hasInvoices ?? p.has_invoices),
    typeLabel:
      p.typeLabel == null && p.type_label == null
        ? null
        : String(p.typeLabel ?? p.type_label ?? ""),
  };
}

/**
 * @param {{
 *   name: string;
 *   sport?: string;
 *   calendarYear: number | string;
 *   startDate: string;
 *   endDate: string;
 *   membershipYearLabel?: string;
 *   licenseYearLabel?: string;
 *   familyMembershipMode?: string;
 *   isActive?: boolean;
 *   isHidden?: boolean;
 *   parentPeriodId?: string | null;
 * }} form
 */
export function billingPeriodFormToApiPayload(form) {
  const license = form.licenseYearLabel;
  return {
    name: form.name.trim(),
    sport: (form.sport || "").trim(),
    calendarYear: Number(form.calendarYear) || new Date().getFullYear(),
    calendar_year: Number(form.calendarYear) || new Date().getFullYear(),
    startDate: form.startDate,
    start_date: form.startDate,
    endDate: form.endDate,
    end_date: form.endDate,
    membershipYearLabel: (form.membershipYearLabel || "").trim(),
    membership_year_label: (form.membershipYearLabel || "").trim(),
    licenseYearLabel: license === "__NOT_USED__" || !license ? "__NOT_USED__" : license,
    license_year_label: license === "__NOT_USED__" || !license ? "__NOT_USED__" : license,
    familyMembershipMode: form.familyMembershipMode === "on" ? "on" : "off",
    family_membership_mode: form.familyMembershipMode === "on" ? "on" : "off",
    isActive: Boolean(form.isActive),
    is_active: Boolean(form.isActive),
    isHidden: Boolean(form.isHidden),
    is_hidden: Boolean(form.isHidden),
    parentPeriodId: form.parentPeriodId || null,
    parent_period_id: form.parentPeriodId || null,
  };
}
